export enum ViewBy {
  cpo = 'CPO',
  roas = 'ROAS'
}
